import { QCONTINUITY_ENTITY } from 'app/shared/constant';
import { CommonSectionIds } from '../common.models';

export const ForesiteULSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    DataDelivery: CommonSectionIds.DataDelivery,
    ConfigureAlarms: CommonSectionIds.ConfigureAlarms,
    DialogActions: CommonSectionIds.DialogActions,
}


export enum ForeSITEULDataDeliveryFieldIds {
    NormalIntervalHours = 'fore-site-ul-normalIntervalHours',
    FastModeEnabled = 'fore-site-ul-fastModeEnabled'
}

export enum ForeSiteULalarmsFieldIds {
    LowLevelEnable = 'fore-site-ul-lowLevelEnable',
    LowLevelThreshold = 'fore-site-ul-lowLevelThreshold',
    HighLevelEnable = 'fore-site-ul-highLevelEnable',
    HighLevelThreshold = 'fore-site-ul-highLevelThreshold',
    HighHighEnable = 'fore-site-ul-highHighEnable',
    HighHighThreshold = 'fore-site-ul-highHighThreshold',
    BatteryLowEnable = 'fore-site-ul-batteryLowEnable',
    BatteryLowThreshold = 'fore-site-ul-batteryLowThreshold',
}


export const ForeSITEUL_CONSTANTS = {
    apnProvider: 'ADSENV.COM',
    fastrate: 300,
    qFinalEntityID: QCONTINUITY_ENTITY,

}

export const INSTALLATION_DEFAULT_CONSTANTS = {
    installationDesc1: '',
    installationDesc2: '',
    installationDesc3: '',
    installationDesc4: '',
    installationDesc5: '',
    wasCreatedFromImport: false,
}

export const FORESITE_UL_MONITOR_CONFIGURATION_CONSTANTS = {
    storetemperature: false,
    storebattery: 1,
}